import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import type { VacationDaysReport } from "~/modules/humanResources/api/vacationDaysReport/vacationDaysReportTypes.ts";

export function getVacationDaysReport():AxiosApiResponsePromise<VacationDaysReport[]>{
	return axiosApi.get('/absences/vacation-days-report')
}